<template>
  <div>
    <v-card class="d-flex justify-start flex-wrap mx-4 my-2" flat>
      <v-select
        class="select"
        item-text="title"
        item-value="bpId"
        :items="LPUList"
        v-model="selectedLPU"
        :multiple="isMonthView"
        label="Выберите ЛПУ"
      >
        <template v-if="isMonthView" v-slot:prepend-item>
          <v-list-item ripple @click="toggleAllLPU">
            <v-list-item-action>
              <v-icon>{{ allLPUIcon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Все учреждения</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
        <template v-if="isMonthView" v-slot:selection="{ index }">
          <span v-if="index === 0">{{ selectionText }}</span>
        </template>
      </v-select>
      <v-spacer></v-spacer>
      <v-select
        :items="viewTypes"
        item-text="title"
        item-value="value"
        v-model="view"
        label="Тип отображения"
      ></v-select>
      <v-spacer></v-spacer>
      <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="monthText"
            label="Дата"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          min="2017-01"
          max="2030"
          v-model="date"
          type="month"
          no-title
          scrollable
          @input="menu = false"
        ></v-date-picker>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn
        class="align-self-center mr-2"
        color="primary"
        :disabled="!choosenLPU.length || loading"
        :loading="loading"
        @click="buildReport"
      >
        Сформировать
      </v-btn>
      <v-btn class="align-self-center" :disabled="!getStatistics.length" @click="exportCsv">
        <v-icon left>mdi-microsoft-excel</v-icon>
        Экспорт
      </v-btn>
    </v-card>
    <div v-if="loading" class="mx-4 mb-2">
      <v-progress-linear :value="progressPercent" height="20" rounded>
        <span class="caption">Собрано {{ reportProgress.done }} из {{ reportProgress.total }}</span>
      </v-progress-linear>
    </div>
    <v-alert v-if="failedLPU.length" type="warning" text dense class="mx-4">
      Не удалось собрать данные: {{ failedLPU.join(', ') }}
    </v-alert>
    <!-- <v-text-field
          v-model="search"
          clearable
          append-icon="mdi-magnify"
          label="Поиск"
          single-line
          hide-details
        ></v-text-field> -->
    <v-data-table
      :headers="tableHeader"
      :items="getStatistics"
      :item-key="itemKey"
      class="elevation-1"
      :items-per-page="100"
      :search="search"
      mobile-breakpoint="0"
      :loading="loading"
      loading-text="Загрузка... Пожалуйста подождите"
      :footer-props="{
        itemsPerPageOptions: [100, -1],
      }"
    >
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      // по умолчанию отчёт за прошлый месяц — текущий ещё не закрыт
      date: moment().subtract(1, 'month').format('YYYY-MM'),
      viewTypes: [
        { title: 'Интервалы', value: 'int' },
        { title: 'День', value: 'day' },
        { title: 'Месяц', value: 'month' },
      ],
      view: 'month',
      menu: false,
      modal: false,
      choosenLPU: [],
      loading: false,
      search: '',
      objectHeaders: [
        { text: 'Дата', value: 'start_int' },
        { text: 'Всего звонков', value: 'all_call' },
        { text: 'Обслуженных', value: 'obsl' },
        { text: 'Потеряных', value: 'lar_all' },
        { text: 'SLA', value: 'sla' },
        { text: 'LAR', value: 'lar' },
        { text: 'ASA', value: 'ASA' },
        { text: 'Доступность', value: 'reach' },
      ],
      objectHeadersMobile: [
        { text: 'Дата', value: 'start_int' },
        { text: 'Всего звонков', value: 'all_call' },
        { text: 'Доступность', value: 'reach' },
      ],
    }
  },
  methods: {
    ...mapActions(['getReports', 'getSockets']),
    ...mapMutations(['clearLines']),
    toggleAllLPU() {
      this.choosenLPU = this.allLPUSelected ? [] : this.LPUList.map((l) => l.bpId)
    },
    async buildReport() {
      if (!this.choosenLPU.length) return
      this.loading = true
      await this.getReports({ bpIds: this.choosenLPU, date: this.date, view: this.view })
      this.loading = false
    },
    // Выгрузка таблицы в CSV: BOM + ';' — чтобы Excel открывал файл двойным кликом
    exportCsv() {
      const rows = this.getStatistics
      if (!rows.length) return
      const escape = (value) => `"${String(value == null ? '' : value).replace(/"/g, '""')}"`
      const csv = [
        this.exportHeaders.map((h) => escape(h.text)).join(';'),
        ...rows.map((row) => this.exportHeaders.map((h) => escape(row[h.value])).join(';')),
      ].join('\r\n')
      const url = URL.createObjectURL(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
  },

  async created() {
    await this.getSockets()
    // по умолчанию выбраны все учреждения, отчёт строится по кнопке
    this.choosenLPU = this.LPUList.map((l) => l.bpId)
    // setInterval(async () => {
    //   await this.getMonotoringObjects();
    // }, 15 * 1000);
  },

  computed: {
    ...mapGetters(['getStatistics', 'LPUList', 'failedLPU', 'reportProgress']),
    isMonthView() {
      return this.view == 'month'
    },
    progressPercent() {
      const { done, total } = this.reportProgress
      return total ? (done / total) * 100 : 0
    },
    // v-select при multiple работает с массивом, иначе со скаляром, а хранится всегда массив
    selectedLPU: {
      get() {
        return this.isMonthView ? this.choosenLPU : this.choosenLPU[0]
      },
      set(value) {
        this.choosenLPU = Array.isArray(value) ? value : value == null ? [] : [value]
      },
    },
    allLPUSelected() {
      return this.LPUList.length > 0 && this.choosenLPU.length === this.LPUList.length
    },
    allLPUIcon() {
      if (this.allLPUSelected) return 'mdi-close-box'
      return this.choosenLPU.length ? 'mdi-minus-box' : 'mdi-checkbox-blank-outline'
    },
    selectionText() {
      if (this.allLPUSelected) return `Все учреждения (${this.choosenLPU.length})`
      if (this.choosenLPU.length === 1) {
        const lpu = this.LPUList.find((l) => l.bpId == this.choosenLPU[0])
        return lpu ? lpu.title : ''
      }
      return `Выбрано: ${this.choosenLPU.length}`
    },
    tableHeader() {
      const headers = this.isMobile ? this.objectHeadersMobile : this.objectHeaders
      return this.choosenLPU.length > 1 ? [{ text: 'Учреждение', value: 'title' }, ...headers] : headers
    },
    exportHeaders() {
      return this.choosenLPU.length > 1
        ? [{ text: 'Учреждение', value: 'title' }, ...this.objectHeaders]
        : this.objectHeaders
    },
    itemKey() {
      return this.choosenLPU.length > 1 ? 'title' : 'start_int'
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    dateLPU() {
      return { date: this.date, bpIds: this.choosenLPU, view: this.view }
    },
    monthText() {
      return moment(this.date, 'YYYY-MM').locale('ru').format('MMMM')
    },
    fileName() {
      let lpu = 'ЛПУ'
      if (this.allLPUSelected) lpu = 'все учреждения'
      else if (this.choosenLPU.length === 1)
        lpu = (this.LPUList.find((l) => l.bpId == this.choosenLPU[0]) || {}).title || lpu
      else if (this.choosenLPU.length > 1) lpu = `${this.choosenLPU.length} учреждений`
      const period = moment(this.date, 'YYYY-MM').format('MM.YYYY')
      return `Отчёт_${lpu}_${period}.csv`.replace(/[\\/:*?"<>|]/g, '_')
    },
  },
  watch: {
    // показанная таблица всегда должна соответствовать фильтрам — иначе остаются данные прошлого запроса
    dateLPU() {
      this.clearLines()
    },
    view(newView) {
      // несколько учреждений сразу имеют смысл только в помесячном виде
      if (newView != 'month' && this.choosenLPU.length > 1) this.choosenLPU = this.choosenLPU.slice(0, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
// .select {
//   width: 80;
// }
</style>
